"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "borghetto-di-vara": {
    "27ff1ffa": [{
      "hkey": "f01796d2",
      "slug": "l-ago",
      "name": "L'Ago",
      "primary": true,
      "skipSearch": false
    }],
    "lago": [{
      "hkey": "f01796d2",
      "slug": "l-ago",
      "name": "L'Ago",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;